/**
 * Product Recently Viewed — injects recently viewed products on the product page
 * by reusing the predictive-search section. Same data & UI as search modal.
 */
import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

const PREDICTIVE_SEARCH_SECTION_ID = 'predictive-search';

/**
 * @param {HTMLElement} container
 */
async function loadRecentlyViewed(container) {
  const grid = container.querySelector('[id^="recently-viewed-grid-"]');
  const currentProductId = container.dataset.productId;

  if (!grid) return;

  const viewedIds = RecentlyViewed.getProducts();
  const idsToFetch = currentProductId
    ? viewedIds.filter((id) => id !== currentProductId)
    : viewedIds;

  if (idsToFetch.length === 0) {
    container.closest('.shopify-section')?.classList.add('hidden');
    return;
  }

  const url = new URL(Theme?.routes?.search_url ?? '/search', location.origin);
  url.searchParams.set('q', idsToFetch.map((id) => `id:${id}`).join(' OR '));
  url.searchParams.set('resources[type]', 'product');

  try {
    const html = await sectionRenderer.getSectionHTML(
      PREDICTIVE_SEARCH_SECTION_ID,
      false,
      url
    );

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const productsEl = doc.getElementById('predictive-search-products');

    if (!productsEl) return;

    const list = productsEl.querySelector('.predictive-search-results__wrapper-products');
    if (!list) return;

    grid.replaceChildren(list.cloneNode(true));
  } catch {
    container.closest('.shopify-section')?.classList.add('hidden');
  }
}

function init() {
  const containers = document.querySelectorAll('.product-recently-viewed');
  for (const container of containers) {
    loadRecentlyViewed(container);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
